export default {
    logout: 'Déconnexion',
    connection_status: 'Connexion statut',
    group_id: 'Identifiant du groupe',
    song_id: 'Identifiant de la chanson',
    waiting_for_song_to_play: 'En attente de la chanson à jouer',
    waiting_for_next_music: 'En attente de la prochaine musique',
    song_name: 'Nom de la chanson',
    artist_name: 'Nom de l\'artiste',
    movie_name: 'Nom du film',
    enter_group_id: 'Entrez le nom du groupe',
    login: 'S\'identifier',
    score: 'Score',
    release: 'Chanson',
    artist: 'Artiste',
    language: 'Langue',
    points: 'Points',
    bonus: 'Bonus',
    movie: 'Film',
    answer_saved: 'Réponse enregistrée',
    correct: 'Correct',
    wrong: 'Faux',
    password: 'Mot de passe',
    error: 'Erreur',
    invalid_password: 'Mot de passe invalide',
    group: 'Groupe',
    connecting: 'Connexion',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    points_obtained: 'Points obtenus',
    total_points: 'Points totaux',
    title: 'Titre',
    id: 'ID',
    failed: 'Échoué',
    lost: 'Perdu',
    no_group_id: 'Identifiant de groupe introuvable',
    set_my_group_id_now: 'Définissez mon identifiant de groupe maintenant',
    rank: 'Rang',
    global_rank: 'Rang global',
    category_rank: 'Rang catégorie',
    leaderboard: 'Classement',
}
